import {
  ApplicationConfig,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
} from '@angular/core';
import {
  provideRouter,
  UrlSerializer,
  withInMemoryScrolling,
} from '@angular/router';
import { appRoutes } from './app.routes';
import {
  provideDataAccessHttp,
  AuthService,
  ENV_CONFIG,
} from '@chefami-monorepo/data-access';
import { environment } from '../environments/environment';
import { EncodedUrlSerializer } from '@chefami-monorepo/utils';
import { sessionExpiredInterceptor } from './interceptors/session-expired.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
    ),
    // Decodes Klaviyo `%3F` links (e.g. /my-ratings%3F_kx=...) before routing.
    { provide: UrlSerializer, useClass: EncodedUrlSerializer },
    // Account is behind login: an unrecoverable session leaves the app.
    provideDataAccessHttp(sessionExpiredInterceptor),
    { provide: ENV_CONFIG, useValue: environment },
    provideAppInitializer(() => {
      const auth = inject(AuthService);
      // BLOCKS app bootstrap until session loaded - ensures tokens available for all subsequent API calls
      return auth.loadSession();
    }),
  ],
};
